

















import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import {Can} from '@casl/vue';
import {DiagTaskTableHeader} from './interfaces';
import diagtaskStoreModule from '@/store/modules/diagtaskModule';

@Component({
  components: {
    TableRoute,
    Can,
  },
})
export default class DiagTasks extends Vue {
  headers: DiagTaskTableHeader[] = [
    {
      text: 'Название',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Описание',
      value: 'description',
      sortable: false,
    },
    {
      text: 'Датчик',
      value: 'accel',
      sortable: false,
    },
  ];

  get apiStore() {
    return diagtaskStoreModule;
  }
}
